<template>
    <div>
        <!-- 面包屑 -->
        <breadcrumbs></breadcrumbs>
        <div class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
            @click="$router.push('/valueAddedService/valueAddedService')">
            <i class="el-icon-arrow-left fw-600"></i>
            返回
        </div>

        <!-- 产品信息 -->
        <!-- <div class="mgt-20 bg-white pd-20">
            <h3 class="title">产品信息</h3>
            <el-descriptions :column="2" border>
                <el-descriptions-item label="产品名称">{{ query.productName }}</el-descriptions-item>
                <el-descriptions-item label="商品名称">{{ query.goodsName }}</el-descriptions-item>
                <el-descriptions-item label="价格">{{ query.price }} 元</el-descriptions-item>
                <el-descriptions-item label="有效期">{{ query.validityPeriod }}</el-descriptions-item>
                <el-descriptions-item label="产品类型">
                    {{ query.type == 1 ? '普通产品' : query.type == 2 ? '特价产品' : query.type == 3 ? '免费产品' : '--' }}
                </el-descriptions-item>
                <el-descriptions-item label="创建时间">{{ query.createTime }}</el-descriptions-item>
            </el-descriptions>
        </div> -->

        <!-- 打款账户信息 -->
        <div class="mgt-20 bg-white pd-20">
            <h3 class="title">打款账户信息</h3>
            <div class="account-info">
                <div class="info-item">
                    <span class="label">账户名称：</span>
                    <span class="value">未来先生公司</span>
                </div>
                <div class="info-item">
                    <span class="label">银行账户：</span>
                    <span class="value">345851351383358</span>
                </div>
                <div class="info-item">
                    <span class="label">开户行：</span>
                    <span class="value">四川农行</span>
                </div>
            </div>
            <div class="warning-text">
                <i class="el-icon-warning"></i>
                <span>支付后请上传打款凭证(试用产品不支持上传凭证)</span>
            </div>

            <!-- 打款凭证上传 -->
            <div class="upload-area mgt-20" v-if="pingzhengupload">
                <div class="upload-title">打款凭证</div>
                <div class="upload-tip">（一次只能上传一张图片，支持JPG、PNG格式）</div>
                <el-upload
                    class="upload-demo"
                    action="#"
                    :headers="uploadHeaders"
                    :on-error="handleUploadError"
                    :on-remove="handleRemove"
                    :before-upload="beforeUpload"
                    :file-list="fileList"
                    :http-request="uploadFile"
                    :limit="1"
                    list-type="picture">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2MB</div>
                </el-upload>
                <!-- <el-upload ref="videoUpload" action="#" :on-success="handleVideoUploadSuccess"
                            :before-upload="beforeVideoUpload" :http-request="uploadFile" :limit="1"
                            accept=".mp4,.avi,.mov" class="upload-demo">
                            <el-button size="small" type="primary">点击上传视频</el-button>
                            <div slot="tip" class="el-upload__tip">支持上传MP4、AVI、MOV格式的视频</div>
                        </el-upload>
                        <div v-if="addGoodsForm.video" class="video-preview">
                            <video :src="addGoodsForm.video" controls width="100%" height="200px"></video>
                            <el-button type="danger" size="small" @click="removeVideo">删除</el-button>
                        </div> -->
            </div>
        </div>

        <!-- 开票信息 -->
        <div class="mgt-20 bg-white pd-20">
            <h3 class="title">开票信息</h3>
            <div class="invoice-option">
                <el-radio-group v-model="needInvoice" @change="handleInvoiceChange">
                    <el-radio :label="0">不需要开票</el-radio>
                    <el-radio :label="1">需要开票</el-radio>
                </el-radio-group>
            </div>

            <!-- 开票表单 -->
            <div v-if="needInvoice === 1" class="invoice-form mgt-20">
                <el-form ref="invoiceForm" :model="invoiceForm" :rules="invoiceRules" label-width="120px">
                    <el-form-item label="发票抬头" prop="invoiceTitle">
                        <el-input v-model="invoiceForm.invoiceTitle" placeholder="请输入发票抬头"></el-input>
                    </el-form-item>
                    <el-form-item label="税号" prop="taxNumber">
                        <el-input v-model="invoiceForm.taxNumber" placeholder="请输入税号"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱地址" prop="email">
                        <el-input v-model="invoiceForm.email" placeholder="请输入接收发票的邮箱地址"></el-input>
                    </el-form-item>
                    <el-form-item label="发票类型" prop="invoiceType">
                        <el-select v-model="invoiceForm.invoiceType" placeholder="请选择发票类型">
                            <el-option label="增值税普通发票" value="1"></el-option>
                            <el-option label="增值税专用发票" value="2"></el-option>
                            <el-option label="其他发票（需备注）" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark">
                        <el-input 
                            v-model="invoiceForm.remark" 
                            type="textarea" 
                            :rows="3" 
                            placeholder="请输入备注信息（如发票类型选择其他，请在此说明）"></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <!-- 确认支付 -->
        <div class="mgt-20 bg-white pd-20 text-center">
            <el-button type="primary" size="large" :loading="submitting" @click="handleSubmit">
                确认支付
            </el-button>
            <!-- <div class="mgt-10 tip-text">
                提交后系统将自动审核您的支付信息
            </div> -->
        </div>
    </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";

export default {
    components: {
        breadcrumbs,
        btns,
    },
    data() {
        // 邮箱验证规则
        const validateEmail = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入邮箱地址'));
            } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
                callback(new Error('请输入正确的邮箱格式'));
            } else {
                callback();
            }
        };

        return {
            query: {},
            needInvoice: 0, // 0-不需要开票，1-需要开票
            invoiceForm: {
                invoiceTitle: '',
                taxNumber: '',
                email: '',
                invoiceType: '',
                remark: ''
            },
            invoiceRules: {
                invoiceTitle: [
                    { required: true, message: '请输入发票抬头', trigger: 'blur' },
                    { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
                ],
                taxNumber: [
                    { required: true, message: '请输入税号', trigger: 'blur' },
                    // { pattern: /^[A-Z0-9]{15}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/, message: '请输入正确的税号格式', trigger: 'blur' }
                ],
                email: [
                    { required: true, validator: validateEmail, trigger: 'blur' }
                ],
                invoiceType: [
                    { required: true, message: '请选择发票类型', trigger: 'change' }
                ]
            },
            fileList: [],
            paymentVoucher: '', // 上传后的凭证URL
            submitting: false,
            uploadUrl: '', // 上传地址，将在created中设置
            uploadHeaders: {
                // 如果需要token认证，可以在这里设置
                // 'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            pingzhengupload: true,
        }
    },
    created() {
        this.query = this.$route.query;
        if(this.query.price==0){
            this.pingzhengupload = false
        }
        console.log('this.query', this.query);
        
        // 设置上传地址（根据实际情况调整）
        this.uploadUrl = process.env.VUE_APP_BASE_API + '/api/upload/header'; // 假设您的接口地址
    },
    methods: {
        // 处理上传成功
        // handleUploadSuccess(response, file, fileList) {
        //     console.log('上传成功:', response);
        //     if (response.code === 200) {
        //         this.paymentVoucher = response.data || response.url; // 根据实际返回的字段调整
        //         handleAlert('上传成功', 'success');
        //     } else {
        //         handleAlert(response.msg || '上传失败', 'error');
        //         // 移除上传的文件
        //         this.fileList = [];
        //         this.paymentVoucher = '';
        //     }
        // },
        uploadFile(params) {
            console.log('开始上传文件:', params.file.name);

            // 检查文件是否存在
            if (!params.file) {
                console.error('文件不存在');
                params.onError(new Error('文件不存在'));
                return;
            }

            let formData = new FormData();
            formData.append("files", params.file);

            console.log('FormData 创建完成，准备发送请求');

            // 先确保接口能正常调用
            this.$api.valueAddedService.uploadHeader(formData)
                .then((res) => {
                    console.log('接口响应原始数据:', res);

                    // 检查响应是否存在
                    if (!res) {
                        console.error('接口返回 undefined');
                        params.onError(new Error('服务器返回空响应'));
                        return;
                    }
                    this.paymentVoucher = res.data[0]  // 根据实际返回的字段调整
        //         handleAlert('上传成功', 'success');


                    // 根据您的接口实际返回结构调整
                    // 假设接口返回 { code: 200, data: {...}, message: '成功' }
                    // if (res.code === 200 || res.success) {
                    //     console.log('上传成功，返回数据:', res.data);
                    //     this.addGoodsForm.video = res.data[0]

                    // } else {
                    //     console.error('上传失败，错误码:', res.code, '消息:', res.message);
                    //     params.onError(new Error(res.message || '上传失败'));
                    // }
                })
                .catch((error) => {
                    console.error('上传请求失败:', error);
                    console.error('错误详情:', {
                        message: error.message,
                        stack: error.stack,
                        response: error.response
                    });
                    params.onError(new Error('网络请求失败: ' + (error.message || '未知错误')));
                });
        },
        
        // 处理上传失败
        handleUploadError(err, file, fileList) {
            console.error('上传失败:', err);
            handleAlert('上传失败，请重试', 'error');
            this.fileList = [];
            this.paymentVoucher = '';
        },
        
        // 移除文件
        handleRemove(file, fileList) {
            this.paymentVoucher = '';
            console.log('文件已移除');
        },
        
        // 上传前检查
        beforeUpload(file) {
            const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;
            
            if (!isImage) {
                handleAlert('只能上传JPG/PNG格式的图片!', 'error');
                return false;
            }
            if (!isLt2M) {
                handleAlert('图片大小不能超过2MB!', 'error');
                return false;
            }
            
            return true;
        },
        
        // 开票选项改变
        handleInvoiceChange(value) {
            if (value === 0) {
                // 重置表单
                this.$refs.invoiceForm && this.$refs.invoiceForm.resetFields();
            }
        },
        
        // 提交支付
        async handleSubmit() {
            // 验证是否上传了凭证
            if (this.pingzhengupload && !this.paymentVoucher) {
                handleAlert('请先上传打款凭证', 'error');
                return;
            }
            
            // 如果需要开票，验证开票信息
            if (this.needInvoice === 1) {
                try {
                    await this.$refs.invoiceForm.validate();
                } catch (error) {
                    handleAlert('请完善开票信息', 'error');
                    return;
                }
            }
            
            // 确认提交
            handleConfirm('确认提交支付信息吗？').then( async () => {
                this.submitting = true;
                try {
                    console.log('点击了提交')
                    // 构建请求参数
                    const params = {
                        needInvoice: this.needInvoice,
                        paymentVoucher: this.paymentVoucher,
                        productId: this.query.id,
                        goodsName: this.query.goodsName,
                        price: this.query.price,
                        productName: this.query.productName,
                        productType: this.query.type,
                        validityDays: this.query.validityDays,
                        validityPeriod: this.query.validityPeriod
                    };
                    if(this.query.price==0){
                        params.paymentVoucher = '';
                    }
                    
                    // 根据是否需要开票添加开票信息
                    if (this.needInvoice === 1) {
                        params.email = this.invoiceForm.email;
                        params.invoiceTitle = this.invoiceForm.invoiceTitle;
                        params.invoiceType = this.invoiceForm.invoiceType;
                        params.remark = this.invoiceForm.remark;
                        params.taxNumber = this.invoiceForm.taxNumber;
                    } else {
                        params.email = '';
                        params.invoiceTitle = '';
                        params.invoiceType = '';
                        params.remark = '';
                        params.taxNumber = '';
                    }
                    
                    console.log('提交参数:', params);
                    
                    // 调用接口
                    const res = await this.$api.valueAddedService.getAddOrder( params );
                    console.log('提交结果:', res);
                    
                    if (res.code === 200) {
                        handleAlert('支付信息提交成功', 'success');
                        // 跳转到订单历史页面
                        this.$router.push({ path: '/valueAddedService/orderHistory' });
                    } else {
                        handleAlert(res.msg || '提交失败', 'error');
                    }
                } catch (error) {
                    console.error('提交失败:', error);
                    // handleAlert('提交失败，请稍后重试', 'error');
                } finally {
                    this.submitting = false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.topReturnLink {
    margin-bottom: 20px;
    cursor: pointer;
    
    &:hover {
        color: var(--accent);
    }
}

.title {
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid var(--table-border);
    color: var(--text-sub);
    font-size: 18px;
}

.bg-white {
    background: var(--card-bg);
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.pd-20 {
    padding: 20px;
}

.mgt-20 {
    margin-top: 20px;
}

.mgt-10 {
    margin-top: 10px;
}

// 账户信息样式
.account-info {
    padding: 15px;
    background: var(--card-bg);
    border-radius: 4px;
    margin-bottom: 20px;
    
    .info-item {
        margin-bottom: 10px;
        
        &:last-child {
            margin-bottom: 0;
        }
        
        .label {
            color: var(--text-sub);
            font-weight: 500;
            min-width: 80px;
            display: inline-block;
        }
        
        .value {
            color: var(--text-main);
            font-weight: bold;
        }
    }
}

// 警告文本
.warning-text {
    color: var(--danger);
    font-size: 14px;
    padding: 10px;
    background: var(--card-bg);
    border-radius: 4px;
    display: flex;
    align-items: center;
    
    i {
        margin-right: 8px;
    }
}

// 上传区域
.upload-area {
    .upload-title {
        font-weight: bold;
        margin-bottom: 5px;
        color: var(--text-sub);
    }
    
    .upload-tip {
        color: var(--text-sub);
        font-size: 12px;
        margin-bottom: 15px;
    }
    
    .upload-demo {
        width: 360px;
    }
}

// 开票选项
.invoice-option {
    padding: 15px;
    background: var(--card-bg);
    border-radius: 4px;
}

// 开票表单
.invoice-form {
    padding: 20px;
    background: var(--card-bg);
    border-radius: 4px;
    border: 1px solid var(--table-border);
    
    .el-form-item {
        margin-bottom: 20px;
    }
}

// 确认按钮区域
.text-center {
    text-align: center;
}

.tip-text {
    color: var(--text-sub);
    font-size: 12px;
}

// 响应式调整
@media (max-width: 768px) {
    .pd-20 {
        padding: 15px;
    }
    
    .upload-demo {
        width: 100%;
    }
}
</style>